export const BUSINESS_UNITS_PATH_NAME = 'business-units';
